module.exports = __webpack_public_path__ + "img/yncx.18cd94eb.png";